import { render, staticRenderFns } from "./MaterialItemFormTable.vue?vue&type=template&id=0d1c5bd3&"
import script from "./MaterialItemFormTable.vue?vue&type=script&lang=ts&"
export * from "./MaterialItemFormTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports